export const TAB_CREATE = 'create';
export const TAB_TRANSFERT = 'transfer';
export const TAB_CERTIFICATES = 'certificates';
